import { DomainModel } from 'domains/models';
import { TimeFormat } from './timeFormat';

interface Props {
  userId: string;
  familyName?: string | null;
  givenName?: string | null;
  name: string | null;
  profileImage?: string | null;
  locale: string;
  timeZone: string;
  startWeekDay?: number;
  isShowSameEventMerge?: boolean;
  isShowEventOverlap?: boolean;
  isShowDeclinedEvent?: boolean;
  isShowWeekends?: boolean;
  calendarViewDays?: number;
  timeFormat?: string;
  extraTimeZones?: string | null;
}

export default class UserSetting extends DomainModel {
  userId: string;
  familyName: string | null;
  givenName: string | null;
  name: string | null;
  profileImage: string | null;
  locale: string;
  timeZone: string;
  startWeekDay: number;
  isShowSameEventMerge: boolean;
  isShowEventOverlap: boolean;
  isShowDeclinedEvent: boolean;
  isShowWeekends: boolean;
  calendarViewDays: number;
  timeFormat: string;
  extraTimeZones: string | null;

  constructor(props: any) {
    super(props);
    this.userId = props.userId;
    this.familyName = props.familyName || null;
    this.givenName = props.givenName || null;
    this.name = props.name;
    this.profileImage = props.profileImage || null;
    this.locale = props.locale;
    this.timeZone = props.timeZone;
    this.startWeekDay = props.startWeekDay || 0;
    this.isShowSameEventMerge = props.isShowSameEventMerge ?? true;
    this.isShowEventOverlap = props.isShowEventOverlap ?? true;
    this.isShowDeclinedEvent = props.isShowDeclinedEvent ?? false;
    this.isShowWeekends = props.isShowWeekends ?? true;
    this.calendarViewDays = props.calendarViewDays || 7;
    this.timeFormat = props.timeFormat || TimeFormat.Time24;
    this.extraTimeZones = props.extraTimeZones || null;
    this._className = 'UserSetting';
  }

  isValid(scopes: string[] | null = null) {
    super.beforeValidate();
    let p = '';

    p = 'userId';
    if (!scopes || scopes.includes(p)) {
      if (!this.userId) {
        this.addError(p, 'E001');
      }
    }

    p = 'name';
    if (!scopes || scopes.includes(p)) {
      if (this.name) {
        if (this.name.length > 64) {
          this.addError(p, 'E001');
        }
      }
    }

    p = 'familyName';
    if (!scopes || scopes.includes(p)) {
      if (this.familyName) {
        if (this.familyName.length > 32) {
          this.addError(p, 'E001');
        }
      }
    }

    p = 'givenName';
    if (!scopes || scopes.includes(p)) {
      if (this.givenName) {
        if (this.givenName.length > 32) {
          this.addError(p, 'E001');
        }
      }
    }

    p = 'locale';
    if (!scopes || scopes.includes(p)) {
      if (this.locale) {
        if (this.locale.length > 32) {
          this.addError(p, 'E001');
        }
      }
    }

    p = 'timeZone';
    if (!scopes || scopes.includes(p)) {
      if (this.timeZone) {
        if (this.timeZone.length > 32) {
          this.addError(p, 'E001');
        }
      }
    }

    return super.isValid();
  }

  static permited = [
    'familyName',
    'givenName',
    'name',
    'profileImage',
    'locale',
    'timeZone',
    'startWeekDay',
    'extraTimeZones',
    'isShowSameEventMerge',
    'isShowEventOverlap',
    'isShowDeclinedEvent',
    'isShowWeekends',
    'calendarViewDays',
    'timeFormat',
  ];

  static permit(updater: any) {
    return super.permit(updater, this.permited);
  }
}
